var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnduranceBlack40X40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#272724",
    d: "M22.1416 17.8551C22.7921 17.2055 23.4762 16.5223 24.2955 15.7041C25.3768 14.6496 26.8546 14 28.4842 14C31.7979 14 34.4842 16.6863 34.4842 20C34.4842 23.3137 31.7979 26 28.4842 26C26.7087 26 25.1134 25.2288 24.0148 24.0032L20.0054 19.9884L15.7045 15.7041C14.6233 14.6496 13.1454 14 11.5159 14C8.20216 14 5.51587 16.6863 5.51587 20C5.51587 23.3137 8.20216 26 11.5159 26C13.2913 26 14.8867 25.2288 15.9853 24.0032L17.8445 22.1464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnduranceBlack40X40);
export default __webpack_public_path__ + "static/media/Endurance-black-40x40.8b2e6ac6f01da887050ac5042459d48a.svg";
export { ForwardRef as ReactComponent };